import { Link } from '@fluentui/react';
import * as React from 'react';
import { getHelpLogger } from '../../../../web/utils/getHelpLogger';
import { capturePageAction } from '../../../../web/utils/oneDsUtil';
import { AlchemyResult } from '../../../models/apiModels';
import {
  IUITabViewInfo,
  ServiceRequestPage,
  ServiceRequestPageType,
  UITabView,
  UITabViewInfo,
} from '../../../models/reduxState';
import { IContactUsStyles, getContactUsClassNames } from '../styles/contactUsStyles';
import { IStyledComponent } from '../styles/themesUI';
import { getString } from '../../../../web/utils/stringLoader';

export interface UnAuthSignInLinkProps {
  unAuthBranchingEnabled: boolean;
  unAuthSignInResult: AlchemyResult;
  showModalitiesStickyFooter: boolean;
  correlationId: string;
  requestHistorySignin?: boolean;
  showAsLinkComponent: boolean;
  isGetHelp: boolean;

  // dispatchers
  dispatchAlchemyFetchUnAuthSchema: () => void;
  toggleUnAuthBranching: () => void;
  updateUITabViewInfo: (uiTabViewInfo: IUITabViewInfo) => void;
  resetContactUsFocus: (value: boolean) => void;
  initializeToPage: (page: ServiceRequestPage) => void;
}

type IUnAuthSignInLinkProps = UnAuthSignInLinkProps & IStyledComponent<IContactUsStyles>;

export class UnAuthSignInLink extends React.Component<IUnAuthSignInLinkProps> {
  public componentDidMount = () => {
    this.props.unAuthBranchingEnabled &&
      this.props.dispatchAlchemyFetchUnAuthSchema();
  };

  public render = () => {
    return this._showUnAuthLink() ? this._unAuthBranchingText() : null;
  };

  private _unAuthBranchingText = () => {
    const bucketId =
      (!!this.props.unAuthSignInResult &&
        !!this.props.unAuthSignInResult.Insights &&
        !!this.props.unAuthSignInResult.Insights[0] &&
        this.props.unAuthSignInResult.Insights[0].BucketId) ||
      '';
    const contactUsClassNames = getContactUsClassNames(this.props.styles, { theme: this.props.theme });
    return this.props.showAsLinkComponent ? (
      <div id="unauth-branching-section">
        <Link
          onClick={this._onUnAuthTextClick}
          onKeyDown={this.onKeyDown}
          id="unAuthBranchingLink"
          data-bi-bhvr="CONTACT"
          data-bi-area="modalitiesSection"
          data-bi-formnm="maxFunnel"
          data-bi-name={bucketId}
          data-bi-isUnauthBranchingLinkClicked="true"
          tabIndex={0}
        >
          {getString('modality_unAuthBranchingText')}
        </Link>
      </div>
    ) : (
      <span id="unauth-branching-section">
        <a
          onClick={this._onUnAuthTextClick}
          onKeyDown={this.onKeyDown}
          className={contactUsClassNames.unAuthLink}
          id="unAuthBranchingLink"
          data-bi-bhvr="CONTACT"
          data-bi-area="modalitiesSection"
          data-bi-formnm="maxFunnel"
          data-bi-name={bucketId}
          data-bi-isUnauthBranchingLinkClicked="true"
          tabIndex={0}
        >
          {
            getString('modality_unAuthBranchingText')
          }
        </a>
      </span>
    );
  };

  private changeTab = () => {
    const uiTabViewInfo = new UITabViewInfo();
    uiTabViewInfo.showAppBarBackButton = this.props.isGetHelp;
    uiTabViewInfo.uITabView = UITabView.requestCreation;
    this.props.updateUITabViewInfo(uiTabViewInfo);
  };

  private _showUnAuthLink = () => {
    return (
      this.props.unAuthBranchingEnabled &&
      getString('modality_unAuthBranchingText', true, true, true) &&
      !!this.props.unAuthSignInResult &&
      !!this.props.unAuthSignInResult.Insights &&
      this.props.unAuthSignInResult.Insights.length > 0
    );
  };

  private _onUnAuthTextClick = () => {
    if (!this.props.requestHistorySignin && this.props.showModalitiesStickyFooter) {
      getHelpLogger.logUnAuthLinkClicked();
      const logHandlerTags = {
        content: {
          contentId: 'stickyFooterUnAuthLink',
          contentName: 'stickyFooterUnAuthLinkClick',
          correlationId: this.props.correlationId,
          formnm: 'maxFunnel',
          fileName: 'UnAuthSignInLink.tsx',
          methodName: '_onUnAuthTextClick',
          areaName: 'modalitiesSection',
        },
        behavior: 'CLICK',
      };
      capturePageAction(null, logHandlerTags);
      this.changeTab();

      const page: ServiceRequestPage = {
        isBackButtonPresent: true,
        serviceRequestPageType: ServiceRequestPageType.SignInSection,
      };
      this.props.initializeToPage(page);
      this.props.resetContactUsFocus(true);
    }

    this.props.toggleUnAuthBranching();
  };

  private onKeyDown = (ev: React.KeyboardEvent<HTMLElement>) => {
    if (ev.key === 'Enter') {
      this._onUnAuthTextClick();
    }
  };
}
